// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#333","menuHover":"#333","subMenuBg":"#222","subMenuHover":"#222","sideBarWidth":"200px"};